<template>
  <div class="menuContainer light-scroll">
    <el-menu ref="menuLeft" mode="vertical" default-active="activityChart" class="el-menu-vertical" v-show="value.length > 0">
      <menu-item v-for="(item, index) in value" :value="item" :key="index"></menu-item>
    </el-menu>
  </div>
</template>

<script>
import menuItem from '@/components/layout/menuItem'
export default {
  name: 'navbar',
  components: {
    menuItem: menuItem
  },
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {}
  }
}
</script>

<style scoped lang="less">
.menuContainer{
  width: 330px;
  height: calc(100vh - 80px);
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  .el-menu-vertical {
    /*width: 270px;*/
    height: calc(100vh - 80px);
    box-sizing: border-box;
    text-align: left;
  }
}
</style>
<style lang="less">
.el-menu-vertical{
  .el-menu-item:focus, .el-menu-item:hover{
    background-color: rgba(22, 119, 255, .1);
  }
  .el-menu-item.is-active{
    background: var(--main-color);
    color: #fff;
  }
  .el-submenu__title{
    color: #333;
    padding: 0 30px;
  }
  .el-submenu{
    .el-menu-item{
      div{
        padding-left: 34px;
      }
    }
  }
}
</style>
